import Vue from 'vue';

export default {
  update(state, payload) {
    state[payload.key] = payload.data;
  },
  updateSubLookup(state, payload) {
    Vue.set(state[payload.key], payload.relatedId, payload.data);
  },
};
